import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Controller, useForm } from "react-hook-form";
import { Button, Grid, TextField, Typography } from "@material-ui/core";

//
import data from "../../data/ContactUs";
import { emailRegex, mobileRegex } from "../../hooks/regex";
import Axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { RootUrl } from "../../redux/types";
import { Alert } from "@material-ui/lab";
import { closeCommonPageModal } from "../../redux/action/utilActions";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: "50vw",
    maxWidth: "50vw",
    [theme.breakpoints.down("md")]: {
      minWidth: "auto",
      maxWidth: "90vw",
    },
  },
  error: {
    fontSize: "0.5rem",
    color: "red",
    [theme.breakpoints.down("md")]: {
      fontSize: "0.7rem",
    },
  },
  email: {
    fontSize: "1.5rem",
    color: theme.palette.primary.main,
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem",
    },
  },
}));

const Suggestions = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [response, setResponse] = React.useState();
  const { register, errors, control, getValues, handleSubmit } = useForm();
  const posturl = useSelector((state) => state.util.commonPageData.postlink);
  const [showOtp, setShowOtp] = React.useState(false);

  const getOtp = async () => {
    await Axios.get(
      `${RootUrl}/sendotp`,
      {
        params: {
          type: "contact",
          mobile: getValues("mobile"),
        },
      },
      {
        headers: {
          "Content-Type": "application/json",

          "Access-Control-Allow-Origin": "*",
          Accept: "*/*",
        },
      }
    ).then((res) => {
      // console.log("response", res);
      if (res.status === 200) {
        setShowOtp(true);
      }
    });
  };
  const onSubmit = async (data) => {
    // console.log("submit", data, posturl);
    // if (data?.otp) {
    await Axios.post(
      `${RootUrl}/addcontactrequest`,

      {
        website: "main",

        ...data,
      },
      {
        headers: {
          "Content-Type": "application/json",

          "Access-Control-Allow-Origin": "*",
          Accept: "*/*",
        },
      }
    )
      .then((res) => {
        // if (res.data.status === "success") {
        setResponse({
          severnity: "success",
          message: "Request submitted succesfully",
        });
        setTimeout(() => {
          dispatch(closeCommonPageModal());
        }, 3000);
        // } else {
        //   setResponse({
        //     severnity: "error",
        //     message: res.data.message || "Failed to submit",
        //   });
        // }
      })
      .catch((err) =>
        setResponse({
          severnity: "error",
          message: "Failed to submit",
        })
      );
    // } else {
    //   getOtp();
    // }
  };

  const renderTextField = (fieldname, label, rules, next) => {
    return (
      <>
        <Controller
          control={control}
          render={({ onChange, onBlur, value }) => (
            <TextField
              fullWidth
              error={errors[fieldname]}
              variant="outlined"
              size="small"
              onChange={onChange}
              label={label}
              {...next}
            />
          )}
          name={fieldname}
          rules={rules}
          defaultValue=""
        />
        {errors[fieldname] && (
          <Typography className={classes.error}>
            {errors[fieldname].message}
          </Typography>
        )}
      </>
    );
  };

  const nameRules = {
    required: {
      value: true,
      message: "Name is required",
    },
  };

  const emailRules = {
    required: {
      value: false,
      message: "Email is required",
    },
    pattern: {
      value: emailRegex,
      message: "Invalid Email address",
    },
  };

  const mobileRules = {
    required: {
      value: true,
      message: "Mobile Number is required",
    },
    pattern: {
      value: mobileRegex,
      message: "Invalid Mobile Number",
    },
  };

  const { name, email, mobile, suggetion } = data.data[0].inputs;
  return (
    <div className={classes.root}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item lg={12} md={12} xs={12} sm={12}>
            <Typography className={classes.email}>
              {data.data[0].emailTitle}: egpanchayat@gmail.com
            </Typography>
          </Grid>
          {response && (
            <Grid item lg={12} md={12} xs={12} s={12}>
              <Alert severity={response.severnity}>{response.message}</Alert>
            </Grid>
          )}
          <Grid item lg={12} sm={12} xs={12} md={12}>
            {renderTextField("name", name.label, nameRules, { required: true })}
          </Grid>

          <Grid item lg={12} sm={12} xs={12} md={12}>
            {renderTextField("email", email.label, emailRules, {
              required: false,
            })}
          </Grid>
          <Grid item lg={12} sm={12} xs={12} md={12}>
            {renderTextField("mobile", mobile.label, mobileRules, {
              required: true,
            })}
          </Grid>
          {showOtp && (
            <>
              <Grid item lg={4} sm={6} xs={6} md={4}>
                {renderTextField(
                  "otp",
                  "otp",
                  {
                    required: {
                      value: true,
                      message: "Otp is required",
                    },
                  },
                  {
                    required: true,
                    fullWidth: false,
                  }
                )}
              </Grid>
              <Grid item lg={6} sm={6} xs={6} md={6}>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => getOtp()}
                >
                  Resend Otp
                </Button>
              </Grid>
            </>
          )}
          <Grid
            item
            container
            justify="center"
            alignItems="center"
            lg={12}
            sm={12}
            xs={12}
            md={12}
          >
            <Grid item lg={4}>
              <Button
                fullWidth
                color="primary"
                type="submit"
                variant="contained"
              >
                {data.data[0].btnTitle}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};
export default Suggestions;

// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import {
//   Grid,
//   Typography,
//   Box,
//   Button,
//   Container,
//   Divider,
//   TextField,
//   Hidden,
// } from "@material-ui/core";
// import { withRouter, useParams, useLocation } from "react-router-dom";
// import Alert from "@material-ui/lab/Alert";

// // import Axios from "axios";

// import ReactHtmlParser from "html-react-parser";
// import data from "../../data/Suggestions";
// import { useHistory } from "react-router-dom";
// import PagesTitle from "../../components/Common/PagesTitle";
// import UseMobile from "../../hooks/useIsMobile";
// import LayoutContainer from "../../components/LayoutsContainer";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     // padding: "3vh 0vw",
//     width: "50vw",
//     [theme.breakpoints.down("md")]: {
//       width: "100%",
//     },
//   },
//   achievementContainer: {
//     // marginTop: theme.spacing(5),
//   },
//   readmoreBtn: {
//     borderRadius: 100,
//   },
//   frame: {
//     height: "100%",
//     width: "100%",
//     [theme.breakpoints.down("md")]: {
//       height: "50vh",
//     },
//   },
//   captcha: {
//     borderRadius: 10,
//     // backgroundImage: `linear-gradient(45deg, #b3b3b3 25%, #3a7cb3 25%, #3a7cb3 50%, #b3b3b3 50%, #b3b3b3 75%, #3a7cb3 75%, #3a7cb3 100%)`,
//     // backgroundSize: "28.28px 28.28px",
//     border: "2px solid",
//     borderColor: theme.palette.primary.main,
//     padding: "0.3vh 2vh",
//     color: theme.palette.primary.main,
//     [theme.breakpoints.down("md")]: {
//       padding: "0.2vh 1vh",
//     },
//   },
//   maintitleContainer: {
//     marginTop: theme.spacing(10),
//     marginBottom: theme.spacing(5),
//     [theme.breakpoints.down("md")]: {
//       marginBottom: theme.spacing(5),
//     },
//   },
//   maintitle: {
//     marginTop: theme.spacing(10),
//     marginBottom: theme.spacing(5),
//     [theme.breakpoints.down("md")]: {
//       marginBottom: theme.spacing(2),
//     },
//   },
// }));

// const GramSchemesLayout = () => {
//   const classes = useStyles();
//   const history = useHistory();

//   const handleNavigate = (link, extenral) => {
//     if (extenral) {
//       return window.open(link, "_blank");
//     }
//     history.push(link);
//   };
//   const [state, setState] = React.useState({
//     name: "",

//     email: "",
//     phone: "",

//     suggestion: "",
//   });
//   const [captcha, setCaptcha] = React.useState({
//     value: "",
//     enteredValue: "",
//   });
//   const [error, setError] = React.useState("");

//   const [requestSuccess, setRequestSuccess] = React.useState(null);

//   const handleChange = (e) => {
//     setError("");
//     const name = e.target.name;
//     const value = e.target.value;

//     setState({
//       ...state,
//       [name]: value,
//     });
//   };
//   const handleCaptchaChange = (e) => {
//     e.preventDefault();
//     setError("");

//     setCaptcha({
//       ...captcha,
//       enteredValue: e.target.value,
//     });
//   };

//   React.useEffect(() => {
//     function keyGen(keyLength) {
//       var val = Math.floor(1000 + Math.random() * 9000);

//       setCaptcha({
//         ...captcha,
//         value: val,
//       });
//       return val;
//     }
//     keyGen(6);
//   }, []);

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     var mailregex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//     // console.log(re.test(this.state.email));
//     var mobileRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
//     if (!mailregex.test(state, email)) {
//       setError("email");
//     }

//     if (!mobileRegex.test(state.phone)) {
//       setError("phone");
//     } else {
//       const data = {
//         name: state.name,
//         email: state.email,
//         phone: state.phone,
//       };
//     }
//   };
// const { name, email, mobile, suggetion } = data.data[0].inputs;

//   const isMobile = UseMobile();
//   return (
//     <div className={classes.root}>
//       <div className={classes.achievementContainer}>
//         {data !== null && data !== undefined && (
//           <Grid container justify="space-evenly">
//             <Grid itel lg={12} className={classes.gridItemContainer}>
//               <Box m={2}>
//                 <div className={classes.contactContainer}>
//                   <div className={classes.formContainer}>
//                     {requestSuccess !== true ? (
//                       <form
//                         onError={(e) => console.log(e)}
//                         onSubmit={(e) => handleSubmit(e)}
//                       >
//                         <Grid container spacing={2}>
//                           {error === "requestfail" && (
//                             <Grid item lg={12} md={12} sm={12} xs={12}>
//                               <Alert severity="error">
//                                 An Error occured, Please try again later.
//                               </Alert>
//                             </Grid>
//                           )}
//                           <Grid item lg={12} md={12} sm={12} xs={12}>
//                             <TextField
//                               variant="outlined"
//                               color="secondary"
//                               fullWidth
//                               size="small"
//                               label={name.label}
//                               required={true}
//                               name="name"
//                               value={state.name}
//                               onChange={(e) => handleChange(e)}
//                             />
//                           </Grid>
//                           <Grid item lg={12} md={12} sm={12} xs={12}>
//                             <TextField
//                               variant="outlined"
//                               color="secondary"
//                               fullWidth
//                               size="small"
//                               inputMode="email"
//                               label={email.label}
//                               required={false}
//                               error={error === "email"}
//                               helperText={
//                                 error === "email" && "Email is not valid"
//                               }
//                               name="email"
//                               value={state.email}
//                               onChange={(e) => handleChange(e)}
//                             />
//                           </Grid>{" "}
//                           <Grid item lg={6} md={6} sm={12} xs={12}>
//                             <TextField
//                               variant="outlined"
//                               color="secondary"
//                               fullWidth
//                               size="small"
//                               label={mobile.label}
//                               inputMode="numeric"
//                               required={true}
//                               error={error === "phone"}
//                               helperText={
//                                 error === "phone" && "Phone Number is not valid"
//                               }
//                               // type="number"
//                               name="phone"
//                               value={state.phone}
//                               onChange={(e) => handleChange(e)}
//                             />
//                           </Grid>
//                           <Grid item lg={6} md={6} sm={12} xs={12}>
//                             <TextField
//                               variant="outlined"
//                               color="secondary"
//                               fullWidth
//                               size="small"
//                               label={suggetion.label}
//                               multiline={true}
//                               rows="5"
//                               inputMode="text"
//                               required={true}
//                               error={error === "suggetions"}
//                               // type="number"
//                               name="suggetion"
//                               value={state.suggetion}
//                               onChange={(e) => handleChange(e)}
//                             />
//                           </Grid>
//                           <Grid item lg={3} md={3} sm={8} xs={8}>
//                             <TextField
//                               variant="outlined"
//                               color="secondary"
//                               fullWidth
//                               size="small"
//                               label="Enter Captcha"
//                               required={true}
//                               // type="number"
//                               error={error === "captcha"}
//                               helperText={
//                                 error === "captcha" && "Captcha does not match"
//                               }
//                               name="captcha"
//                               value={state.captcha}
//                               onChange={(e) => handleCaptchaChange(e)}
//                             />
//                           </Grid>
//                           <Grid
//                             item
//                             lg={3}
//                             md={3}
//                             sm={4}
//                             xs={4}
//                             container
//                             alignItems="center"
//                             justify="flex-start"
//                             className={classes.captchabg}
//                           >
//                             <Typography
//                               variant="h6"
//                               className={classes.captcha}
//                             >
//                               {captcha.value}
//                             </Typography>
//                           </Grid>
//                           <Grid item lg={4} md={4} sm={6} xs={6}>
// <Button
//   fullWidth
//   color="primary"
//   type="submit"
//   variant="contained"
// >
//   {data.data[0].btnTitle}
// </Button>
//                           </Grid>
//                         </Grid>
//                       </form>
//                     ) : (
//                       <Alert severity="success">{data.successMsg}</Alert>
//                     )}
//                   </div>
//                 </div>
//               </Box>
//             </Grid>
//           </Grid>
//         )}
//       </div>
//     </div>
//   );
// };
// export default GramSchemesLayout;
